import React from 'react'
import './head.css'
const HeadImage = (props) => {
    return (
        <>
            <div className="header-img-block">
                <div className="transparent">
                    <p>{props.title}</p>
                </div>
            </div>
        </>
    )
}

export default HeadImage